import { render, staticRenderFns } from "./file-clean-button.vue?vue&type=template&id=29c892d6&"
import script from "./file-clean-button.vue?vue&type=script&lang=ts&"
export * from "./file-clean-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c892d6')) {
      api.createRecord('29c892d6', component.options)
    } else {
      api.reload('29c892d6', component.options)
    }
    module.hot.accept("./file-clean-button.vue?vue&type=template&id=29c892d6&", function () {
      api.rerender('29c892d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/file-clean-button.vue"
export default component.exports